const DEFAULT_BOX_ANIMATE_TYPE = "none";
const DEFAULT_BOX_ANIMATE_DELAY = 0;
const DEFAULT_BOX_ANIMATE_DURATION = 0.75;
const DEFAULT_ITEM_ANIMATE_TYPE = "none";
const DEFAULT_ITEM_ANIMATE_DELAY = 0;
const DEFAULT_ITEM_ANIMATE_DURATION = 0.75;
const DEFAULT_ITEM_STAGGER_DURATION = 0;
export {
  DEFAULT_BOX_ANIMATE_DELAY,
  DEFAULT_BOX_ANIMATE_DURATION,
  DEFAULT_BOX_ANIMATE_TYPE,
  DEFAULT_ITEM_ANIMATE_DELAY,
  DEFAULT_ITEM_ANIMATE_DURATION,
  DEFAULT_ITEM_ANIMATE_TYPE,
  DEFAULT_ITEM_STAGGER_DURATION
};
//# sourceMappingURL=constants.js.map